import { type UseQueryOptions, useQuery } from '@tanstack/react-query'

import { useGoogleMaps } from './useGoogleMaps'

export const useAdminMeQueryKey = 'get-admin-me'

export const useGooglePlacePredictions = (
  request: google.maps.places.AutocompletionRequest,
  options?: Omit<
    UseQueryOptions<google.maps.places.AutocompleteResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { getPlacePredictions } = useGoogleMaps()

  return useQuery({
    queryKey: ['google-maps/getPlacePredictions', request],
    queryFn: async () => {
      return getPlacePredictions(request)
    },
    ...options,
  })
}
